import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.servers.winloses;

export const serversWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
